import { useCollectKybDataMachine } from '../components/machine-provider';

export default useCollectKybDataMachine;
